import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useStatistics = ({ startDate, endDate, userId } = {}) => {
    const [loading, setLoading] = useState(true);
    const [statistics, setStatistics] = useState({});

    useEffect(() => {
        const fetchStatisticsData = async () => {
            setLoading(true);
            try {
                const params = {};
                if (startDate) params.startDate = startDate;
                if (endDate) params.endDate = endDate;
                if (userId) params.userId = userId;

                const { data } = await api.get("/dashboard/stats", { params });
                setStatistics(data);
                setLoading(false);
            } catch (err) {
                setLoading(false);
                toastError(err);
            }
        };
        fetchStatisticsData();
    }, [startDate, endDate, userId]);

    return { statistics, loading };
};

export default useStatistics;
